import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  Button,
  Modal,
  message,
  Input,
  Select,
} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";
import TableSection from "./childrens/tableList";
import EmployeeService from "../../../services/EmployeeService"; 
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;

const Deactivated = (props) => {
  const [activateConfirm, setActivateConfirm] = useState(false);
  const [userList, setUserList] = useState([]);
  const [defaultPage, setDefaultPage] = useState(1);
  const [searchText, setSearchText] = useState('');

  const getAllUsers = (text = "") => {
    const restaurant_id = props.adminRestaurant;
    EmployeeService.getDeactiveEmploye(restaurant_id, defaultPage, text).then((resp)=>{
      setUserList(resp);
    });
  };

  useEffect(()=>{
    getAllUsers();
  },[props.adminRestaurant, defaultPage]);

  const onSearchText = (e) => {
    setSearchText(e.target.value);
    setDefaultPage(1);
    getAllUsers(e.target.value);
  };
  const onReactive = (record) => {
    setActivateConfirm(record);
  };
  const updateStatus = () => {
    const restaurant_id = props.adminRestaurant;
    EmployeeService.changeEmployeStatus(activateConfirm.id, restaurant_id).then((resp)=>{
      if(resp) {
        getAllUsers();
        setActivateConfirm(false);
        message.success("Successfully activated");
      }
    });
  };
  return (
    <Layout className="u-page-layout">
      <Content className="mem__setting_ui page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader 
          className="page-header"
            title="Deactivated Employees" 
            extra={[
              <div style={{ display: "flex" }}>
              <Input
                prefix={<SearchOutlined style={{ color: "#262626" }} />}
                placeholder="Search Employee"
                onChange={onSearchText}
              />
              <Select
                placeholder="Filter"
                style={{ width: 140 }}
                options={[
                  {
                    value: "Name",
                    label: "Name",
                  },
                  {
                    value: "PhoneNO",
                    label: "Phone No",
                  },
                ]}
              />
            </div>
            ]}
            style={{ background: "#f0f2f5" }} />
          <div>
            <TableSection 
              onReactive={onReactive} 
              userList={userList || []} 
              setDefaultPage={setDefaultPage}
              defaultPage={defaultPage}
            />
          </div>
          <Modal visible={activateConfirm} footer={null} onCancel={()=>setActivateConfirm(false)} className="member_deleteconfirm">
            <div className="confirm_wrap">
              <h3 className="title">Are you sure?</h3>
              <div className="content">Do you really want to activate? </div>
              <div className="btn_section">
                    <Button type="default" className='field_save_btn' style={{ width:"200px", height: "35px", marginRight: "10px" }} onClick={()=>setActivateConfirm(false)}>Cancel</Button>
                    <Button type="primary" className='field_save_btn' style={{ width:"200px", height: "35px" }} onClick={updateStatus}>Reactive</Button>
              </div>
            </div>
          </Modal>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Deactivated));
